module.exports = __webpack_public_path__ + "img/home-banner1.e06fb433.png";